<template>
  <div>
    <el-dialog
      custom-class="cookie-policy-dialog"
      :visible="otherPageShowCookieDialog"
      :close-on-click-modal="false"
      top="0"
      :close-on-press-escape="false"
      :show-close="false"
      width="700px"
      :destroy-on-close="true"
      center
    >
      <!-- 简易视图 -->
      <div v-if="!showDetails" class="cookie-simple-view">
        <div class="header">
          <h3 class="title">隐私与Cookie使用说明</h3>
          <span
            @click="toggleDetails"
            v-if="activeTab === 'cookie' && isShowCookieDialog"
            class="text-link reject-link"
            >Cookie设置</span
          >
        </div>

        <div class="tabs">
          <span
            :class="['tab', { active: activeTab === 'cookie' }]"
            @click="activeTab = 'cookie'"
            v-if="isShowCookieDialog"
          >
            Cookie政策
          </span>
          <span
            :class="['tab', { active: activeTab === 'privacy' }]"
            @click="activeTab = 'privacy'"
            v-if="isShowPrivacyDialog"
          >
            隐私政策
          </span>
        </div>
        <div v-if="activeTab === 'cookie'">
          <p class="description">
            本网站使用
            <span class="text-bold" @click="goCookiePolicy">《Cookie政策》</span>
            及类似技术（含第三方Cookie）用于保障网站运行、统计分析，为您提供更完善的服务体验。除必要Cookie外，这些技术还将记住您的偏好，为您带来更优质的浏览体验。
          </p>
          <p class="description">
            当您点击「全部接受」，即表明您同意启用所有
            Cookie。若您选择关闭横幅「继续而不接受」，相关Cookie将不会保存至您的设备。您还可以通过点击「Cookie设置」，查看收集的Cookie信息。
          </p>
        </div>
        <div v-else>
          <p class="description">
            欢迎您使用Onitsuka
            Tiger官网。为更好地保护您的个人信息和隐私，我们根据法律法规要求对
            <span
              class="text-bold"
              @click="goPrivacyPolicy"
              >《隐私政策》</span>进行了更新。
          </p>
          <p class="description">
            当您点击同意并开始使用服务时，即表示您已理解并同意该条款内容，该条款将对您产生法律约束力。如您拒绝，很遗憾您可能无法完整体验我们官网的全部功能。
          </p>
        </div>

        <!-- <div class="policy-links">
          <span class="text-link" @click="goPrivacyPolicy">隐私政策</span>
          <span class="text-link" @click="goCookiePolicy">Cookie政策</span>
        </div> -->

        <div class="footer">
          <button @click="rejectNonEssential" class="settings-btn">继续但不接受</button>
          <button @click="acceptAll" class="accept-btn">全部接受</button>
        </div>
      </div>

      <!-- 详细视图 -->
      <div v-else class="cookie-details-view">
        <div class="details-header">
          <span class="title">Cookie设置</span>
          <i class="el-icon-close close-icon" @click="toggleDetails"></i>
        </div>

        <div class="details-content">
          <div class="scrollable-area">
            <div class="section">
              <h3>必要的Cookie（始终启用）</h3>
              <p class="section-desc">
                技术Cookie是确保网站正常运行或您能使用所请求服务和内容绝对必需的Cookie。您可以将浏览器设置为阻止此类Cookie或通知您有此类Cookie，如您选择阻止，本网站的某些部分将无法使用。
              </p>

              <div class="cookie-table">
                <div class="table-container">
                  <table>
                    <thead>
                      <tr>
                        <th>名称</th>
                        <th>提供商</th>
                        <th>目的</th>
                        <th>期限</th>
                        <th>类型</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>JSESSIONID</td>
                        <td rowspan="4">udesk</td>
                        <td rowspan="4">客服</td>
                        <td>会话期间</td>
                        <td>http</td>
                      </tr>
                      <tr>
                        <td>_helpdesksystem_session</td>
                        <td>会话期间</td>
                        <td>http</td>
                      </tr>
                      <tr>
                        <td>acw_tc</td>
                        <td>1天</td>
                        <td>http</td>
                      </tr>
                      <tr>
                        <td>aliyungf_tc</td>
                        <td>会话期间</td>
                        <td>http</td>
                      </tr>
                      <tr>
                        <td>mpuv</td>
                        <td>腾讯电脑</td>
                        <td>腾讯电脑</td>
                        <td>1天</td>
                        <td>非http</td>
                      </tr>
                      <tr>
                        <td>acw_sc</td>
                        <td>阿里云</td>
                        <td>阿里云请求序列</td>
                        <td>1天</td>
                        <td>http</td>
                      </tr>
                      <tr>
                        <td>PHPSESSID</td>
                        <td rowspan="3">baiqiu</td>
                        <td>维持session</td>
                        <td>会话期间</td>
                        <td>非http</td>
                      </tr>
                      <tr>
                        <td>userInfo</td>
                        <td rowspan="2">Cms获取用户信息</td>
                        <td>会话期间</td>
                        <td>非http</td>
                      </tr>
                      <tr>
                        <td>token</td>
                        <td>1年</td>
                        <td>非http</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="section">
              <h3>统计Cookie</h3>

              <div class="cookie-table">
                <div class="table-container">
                  <table>
                    <thead>
                      <tr>
                        <th>名称</th>
                        <th>提供商</th>
                        <th>目的</th>
                        <th>期限</th>
                        <th>类型</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>_ga</td>
                        <td rowspan="4">Google Analytics</td>
                        <td rowspan="4">GA统计</td>
                        <td>1月</td>
                        <td>非http</td>
                      </tr>
                      <tr>
                        <td>_ga_ON6JL46GMGZ</td>
                        <td>1月</td>
                        <td>非http</td>
                      </tr>
                      <tr>
                        <td>_gid</td>
                        <td>1天</td>
                        <td>非http</td>
                      </tr>
                      <tr>
                        <td>_gat_gtag_UA_167964323_2</td>
                        <td>1天</td>
                        <td>非http</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="footer">
            <el-button @click="toggleDetails" class="secondary-btn">返回</el-button>
            <el-button @click="acceptAll" class="primary-btn">全部接受</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";

export default {
  data() {
    return {
      showDetails: false,
      activeTab: "cookie",
      // 增加本地存储的key常量
      STORAGE_KEY: {
        COOKIE: "cookieAccept",
        PRIVACY: "privacyAccept",
        PRIVACY_VERSION: "privacyPolicyVersion",
      },
      isShowCookieDialog: false,
      isShowPrivacyDialog: false,
      PrivacyPolicyVersion: ''
    };
  },
  async mounted() {
    await this.checkPrivacyPolicyVersion();
    this.checkCookieAndPolicyStatus();
  },
  methods: {
    async checkPrivacyPolicyVersion() {
      try {
        const res = await api[types.GET_OSS_MP_CONFIG]();
        const { PrivacyPolicyVersion = '' } = res?.data || {}
        this.PrivacyPolicyVersion = PrivacyPolicyVersion;
        if (!PrivacyPolicyVersion) return;
        const localVersion = localStorage.getItem(this.STORAGE_KEY.PRIVACY_VERSION);

        if (PrivacyPolicyVersion !== localVersion) {

          localStorage.setItem(this.STORAGE_KEY.PRIVACY_VERSION, PrivacyPolicyVersion);
          this.activeTab = "privacy";
          this.isShowPrivacyDialog = true;
          this.$store.commit(types.SHOW_COOKIE_DIALOG, true);
        }
      } catch (e) { console.warn(e); }
    },
    checkCookieAndPolicyStatus() {
      this.isShowCookieDialog = false;
      this.isShowPrivacyDialog = false;
      // 检查本地存储中是否已有Cookie设置      
      const cookieAccept =
        JSON.parse(localStorage.getItem(this.STORAGE_KEY.COOKIE)) || {};
      const privacyAccept =
        JSON.parse(localStorage.getItem(this.STORAGE_KEY.PRIVACY)) || {};
      
      this.$store.commit(types.SET_COOKIE_ACCEPT, cookieAccept);
      this.$store.commit(types.SET_PRIVACY_ACCEPT, privacyAccept);

      if (privacyAccept.timestamp) {
        if (privacyAccept.accept) {
          if (utils.isExpired(privacyAccept.timestamp)) {
            this.activeTab = "privacy";
            this.isShowPrivacyDialog = true;
            this.$store.commit(types.SHOW_COOKIE_DIALOG, true);
          }
        } else {
          if (utils.isExpired(privacyAccept.timestamp, 0)) {
            this.activeTab = "privacy";
            this.isShowPrivacyDialog = true;
            this.$store.commit(types.SHOW_COOKIE_DIALOG, true);
          }
        }
      } else {        
        this.activeTab = "privacy";
        this.isShowPrivacyDialog = true;
        this.$store.commit(types.SHOW_COOKIE_DIALOG, true);
      }

      if (cookieAccept.timestamp) {
        if (cookieAccept.accept) {
          if (utils.isExpired(cookieAccept.timestamp)) {
            this.activeTab = "cookie";
            this.isShowCookieDialog = true;
            this.$store.commit(types.SHOW_COOKIE_DIALOG, true);
          }
        } else {
          if (utils.isExpired(cookieAccept.timestamp, 0)) {
            this.activeTab = "cookie";
            this.isShowCookieDialog = true;
            this.$store.commit(types.SHOW_COOKIE_DIALOG, true);
          }
        }
      } else {
        this.activeTab = "cookie";
        this.isShowCookieDialog = true;
        this.$store.commit(types.SHOW_COOKIE_DIALOG, true);
      }
    },
    // 切换详细视图
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
    goPrivacyPolicy() {
      window.open(
        "https://www.onitsukatiger.com/cn/zh-cn/cms/privacy-policy",
        "_blank"
      );
    },
    goCookiePolicy() {
      window.open(
        "https://legal.asics.com/cn-cn/legal/cookie-policy",
        "_blank"
      );
    },

    // 全部接受Cookie
    acceptAll() {
      this.saveCookieSettings(true);
    },

    // 只接受必要Cookie
    rejectNonEssential() {
      this.saveCookieSettings(false);
    },
    checkOtherDialog() {
      if (this.activeTab === "cookie") {
        const privacyAccept =
          JSON.parse(localStorage.getItem(this.STORAGE_KEY.PRIVACY)) || {};
        if (utils.isExpired(privacyAccept.timestamp)) {
          this.activeTab = "privacy";
        } else {
          this.$store.commit(types.SHOW_COOKIE_DIALOG, false);
        }
      } else if (this.activeTab === "privacy") {
        const cookieAccept =
          JSON.parse(localStorage.getItem(this.STORAGE_KEY.COOKIE)) || {};
        if (utils.isExpired(cookieAccept.timestamp)) {
          this.activeTab = "cookie";
        } else {
          this.$store.commit(types.SHOW_COOKIE_DIALOG, false);
        }
      }
    },

    // 保存自定义设置并关闭弹窗
    saveSettings() {
      this.saveCookieSettings(true);
      this.$store.commit(types.SHOW_COOKIE_DIALOG, false);
      this.showDetails = false;
    },

    // 保存Cookie设置到本地存储和Vuex store
    saveCookieSettings(accept) {
      // 按照要求的格式保存
      const cookieData = {
        timestamp: new Date().getTime(),
        accept: accept,
      };
      
      if (this.activeTab === "privacy") {
        localStorage.setItem(
          this.STORAGE_KEY.PRIVACY,
          JSON.stringify(cookieData)
        );
        this.$store.commit(types.SET_PRIVACY_ACCEPT, cookieData);
        const params = {
          action: accept ? 'accepted' : 'rejected',
          policy_version: this.PrivacyPolicyVersion || '1.0'
        }
        api[types.SAVE_CLICK_ACTION](params)
      } else {
        localStorage.setItem(
          this.STORAGE_KEY.COOKIE,
          JSON.stringify(cookieData)
        );
        this.showDetails = false;
        this.$store.commit(types.SET_COOKIE_ACCEPT, cookieData);
      }
      this.checkOtherDialog();
      // 如果不接受统计Cookie，可以在这里禁用相关脚本
      if (!accept) {
        // 禁用Google Analytics等分析工具的代码
        // window['ga-disable-UA-XXXXXXXX-X'] = true;
      }
    },

    // 仅用于测试：重置Cookie设置
    resetCookieSettings() {
      localStorage.removeItem("cookieAccept");
      this.$store.commit(types.SET_COOKIE_ACCEPT, null);
      window.location.reload();
    },
  },
  computed: {
    otherPageShowCookieDialog: {
      get() {
        return this.$store.state.showCookieDialog;
      },
      set(value) {
        this.$store.commit(types.SHOW_COOKIE_DIALOG, value);
      },
    },
  },
  watch: {
    // 监听 Vuex store 中的 showCookieDialog 状态变化
    "$store.state.showCookieDialog": {
      handler(newVal, oldVal) {
        // 当状态发生变化时，重新检查 Cookie 和政策状态
        if (newVal !== oldVal) {
          this.checkCookieAndPolicyStatus();
        }
      },
      immediate: false // 不立即执行，只在变化时执行
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cookie-policy-dialog {
  top: 50%;
  transform: translateY(-50%);

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}

// 简易视图样式
.cookie-simple-view {
  padding: 40px;
  word-break: break-word;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    padding-bottom: 24px;

    .title {
      font-size: 18px;
      line-height: 1.5;
      font-weight: 500;
      margin: 0;
      color: #212322;
    }

    .reject-link {
      position: relative;
      top: -20px;
    }
  }

  .text-link {
    color: #212322;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    border-bottom: 1px solid #212322;
  }

  .text-bold {
    font-weight: bold;
    cursor: pointer;
    color: #212322;
  }

  .description {
    margin-bottom: 24px;
    line-height: 20px;
    font-size: 14px;
    color: #666666;
  }

  .policy-links {
    margin-top: 20px;

    .text-link {
      margin-right: 24px;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 32px;
  }

  .settings-btn {
    flex: 1;
    background-color: white;
    border: 1px solid #7f0019;
    border-radius: 0;
    padding: 12px 20px;
    color: #7f0019;
    cursor: pointer;
  }

  .accept-btn {
    flex: 1;
    background-color: #7f0019;
    color: white;
    border: none;
    border-radius: 0;
    padding: 12px 20px;
    cursor: pointer;
  }
}

.tabs {
  display: flex;
  gap: 20px;
  justify-content: space-around;
  width: 70%;
  text-align: center;
  margin: auto;
  align-items: center;
  padding-bottom: 12px;

  .tab {
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
    color: #999;
    cursor: pointer;
    padding-bottom: 2px;
    border-bottom: 1px solid transparent;
    // flex: 1;
    text-align: center;
  }

  .tab.active {
    color: #212322;
    border-bottom: 1px solid #212322;
  }

  .reject-link {
    position: relative;
    top: -10px;
  }
}

// 详细视图样式
.cookie-details-view {
  display: flex;
  flex-direction: column;
  height: 80vh;
  max-height: 700px;
  word-break: break-word;

  .details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 40px 24px;
    position: relative;

    .title {
      font-size: 18px;
      font-weight: bold;
    }

    .close-icon {
      cursor: pointer;
      font-size: 24px;
      color: #212322 !important;
      position: relative;
      top: -20px;
      right: -20px;
    }

    &::after {
      content: '';
      display: block;
      margin: 0 40px;
      width: calc(100% - 80px);
      height: 1px;
      background-color: #eee;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  .details-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
    overflow: hidden;

    .scrollable-area {
      flex: 1;
      overflow-y: auto;
      padding: 0 40px;
      margin: 24px 0;

      &::-webkit-scrollbar {
        width: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #888;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #555;
      }

      .section {
        margin-bottom: 32px;

        &:last-child {
          margin-bottom: 0;
        }

        h3 {
          margin-bottom: 16px;
          font-size: 14px;
          line-height: 20px;
          color: #212322;
          font-weight: 500;

        }

        .section-desc {
          margin-bottom: 16px;
          font-size: 14px;
          line-height: 20px;
          color: #666666;
        }
      }
    }

    .cookie-table {
      .table-container {
        width: 100%;
        overflow-x: auto;

        table {
          width: 100%;
          border-collapse: collapse;
          white-space: nowrap;

          th,
          td {
            padding: 15px 16px;
            text-align: left;
            border: 1px solid #e0e0e0;
            font-size: 12px;
            line-height: 18px;
            background-color: #fff;
          }

          th {
            background-color: #f5f5f5;
            font-weight: normal;
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: space-between;
      padding: 20px 40px 40px;
      border-top: 1px solid #ccc;
      background-color: white;

      .secondary-btn {
        flex: 1;
        background-color: white;
        border: 1px solid #7f0019;
        border-radius: 0;
        padding: 12px 20px;
        color: #7f0019;
        cursor: pointer;
      }

      .primary-btn {
        flex: 1;
        background-color: #7f0019;
        color: white;
        border: none;
        border-radius: 0;
        padding: 12px 20px;
        cursor: pointer;
      }
    }
  }
}

// 保持按钮水平排列，但允许表格横向滚动
@media only screen and (max-width: 768px) {
  ::v-deep .cookie-policy-dialog {
    width: 95% !important;
  }

  // 在移动端让文本更小而不改变布局结构
  .cookie-simple-view {
    padding: 30px;

    .header {
      .reject-link {
        top: -10px;
      }
    }
  }

  .cookie-details-view {
    .details-header {
      padding: 24px;

      &::after {
        width: calc(100% - 48px);
        margin: 0 24px;
      }

      .close-icon {
        top: -10px;
        right: -10px;
      }
    }

    .details-content {
      .scrollable-area {
        padding: 0 24px;
      }

      .footer {
        padding: 20px 24px 24px;
      }
    }
  }
}
</style>
